export function createWith<T extends object, K extends keyof T>(prototype: T, properties: { [P in K]: T[P] }) {
  return Object.assign(Object.create(prototype), properties) as T;
}
